import { render, staticRenderFns } from "./SurveyManagementEditNumberQuestion.vue?vue&type=template&id=7e508ae7&"
import script from "./SurveyManagementEditNumberQuestion.vue?vue&type=script&lang=js&"
export * from "./SurveyManagementEditNumberQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SurveyManagementEditNumberQuestion.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e508ae7')) {
      api.createRecord('7e508ae7', component.options)
    } else {
      api.reload('7e508ae7', component.options)
    }
    module.hot.accept("./SurveyManagementEditNumberQuestion.vue?vue&type=template&id=7e508ae7&", function () {
      api.rerender('7e508ae7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-management/edit-question/questions/SurveyManagementEditNumberQuestion.vue"
export default component.exports